'use strict'

import {Vue} from 'ui.vue';
import {Plugin} from './lib/plugin';

Vue.use(Plugin);

export {Plugin as Request};